export const getApiBaseUrl = (): string => {
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
  if (!API_BASE_URL) {
    throw new Error('API base URL is not configured');
  }
  return API_BASE_URL;
};